import React from 'react';
import { Icon } from './Icon.js';
export const IconPhoneCheck = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M1.95406 4.91886L2 4H8L9.5 9.5L7.5 11.5C8.11552 13.9621 10.0379 15.8845 12.5 16.5L14.5 14.5L20 16V22C10.0174 23.0508 1.4528 14.9441 1.95406 4.91886Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M14 6L16 8L21 3", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPhoneCheck.js.map